/**
 * Input Schema of TokenPush
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

/* TODO: review generated schema */
export class InputTokenPushSchema extends Schema {
  collectionMotorista = new MotoristaCollection().noPagination()

  readonly name = 'InputTokenPush'

  readonly fieldSet: FieldSet<TokenPush> = {
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    token: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    modeloAparelho: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    marcaAparelho: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
